<template>
  <div class="box-forget">
    <el-form class="portal-form" ref="elForm" :model="form" :rules="rules">
      <el-form-item prop="phone">
        <el-input placeholder="请输入您的手机号" v-model="form.phone" />
      </el-form-item>
      <el-form-item prop="vCode">
        <sms-code
          req-method="smsCode_login"
          v-model="form.vCode"
          :phone="form.phone"
          :verify-data="verifyData"
        ></sms-code>
      </el-form-item>
      <el-form-item class="slider-validation">
        <slider-validation source="validation" @verify-success="verifySuccess"></slider-validation>
      </el-form-item>
    </el-form>
    <el-button type="primary" class="btn-ok btn-top" @click="onOK">登&nbsp;&nbsp;录</el-button>
    <div class="register">
      <a @click="onJoin">注册账号</a>
    </div>
  </div>
</template>

<script>
import loginMixin from './login';
import smsCode from './sms-code';
import SliderValidation from './slider-validatioin/index.vue';

export default {
  mixins: [loginMixin],
  components: {
    smsCode,
    SliderValidation,
  },
  data() {
    return {
      form: {
        phone: '',
        vCode: '',
        identityType: 4,
      },
      rules: {
        phone: {
          required: true,
          message: '请输入您的手机号',
        },
        vCode: {
          required: true,
          message: '请输入验证码',
        },
      },
    };
  },
  methods: {
    verifySuccess(result) {
      this.verifyData = result;
    },
    onOK() {
      this.$refs.elForm.validate((valid) => {
        if (!valid) {
          return;
        }
        this.login(this.form);
      });
    },
    onJoin() {
      window.top.location.href = '/join.html';
    },
  },
};
</script>

<style lang="less" scoped>
.box-forget {
  color: #333333;
  margin-left: 52px;
}
.slider-validation {
  /deep/ .el-form-item__content {
    height: 194px !important;
    border: none !important;
  }
}
.register {
  width: 310px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: right;
  color: #999999;
  line-height: 20px;
  margin-top: 8px;
}
.btn-ok {
  width: 308px;
  height: 54px;
  background: #2e8dff;
  border-radius: 4px;
  margin-top: 40px;
  font-size: 20px;
}
</style>
